import React from 'react';
import Styledlink from '../StyledLink/StyledLink';
import './Auth.scss';
import { Link } from 'react-router-dom';
const Auth=()=>{
    return(
        <div className="auth-btns">
            <Link to="/login">
                <Styledlink btn="Log In" styles="outline" />
            </Link>
            <Link to="sign-up">
                <Styledlink btn="Sign Up "/>
            </Link>
        </div>
    )
};
export default Auth ;